import { useMutation } from '@tanstack/react-query'
import { useToast } from '@chakra-ui/react'
import { CommunityFeatures, InternalFeatures, ExternalFeatures } from '@homevest/types/homes'

import axios from 'lib/axios'

export const useUpsertCommunityFeatures = () => {
  const toast = useToast()
  const { mutate: editCommunityFeatures } = useMutation({
    mutationFn: async ({ communityId, data }: { communityId: string; data: CommunityFeatures }) => {
      if (!communityId) {
        return
      }
      return axios.put(`/admin/portfolio_homes/${communityId}/community_features`, data)
    },
    onSuccess: () => {
      toast({
        title: 'Community Features Edited',
        status: 'success',
        duration: 5000,
        position: 'bottom-right'
      })
    },
    onError: (error: any) => {
      toast({
        title: 'Error Editing Community Features',
        description: error?.message || 'An unknown error occurred',
        status: 'error',
        duration: 5000,
        position: 'bottom-right'
      })
    }
  })

  return editCommunityFeatures
}

export const useUpsertInternalFeatures = () => {
  const toast = useToast()
  const { mutate: editInternalFeatures } = useMutation({
    mutationFn: async ({
      portfolioHomeId,
      data
    }: {
      portfolioHomeId: string
      data: InternalFeatures
    }) => {
      if (!portfolioHomeId) {
        return
      }
      return axios.put(`/admin/portfolio_homes/${portfolioHomeId}/internal_features`, data)
    },
    onSuccess: () => {
      toast({
        title: 'Internal Features Edited',
        status: 'success',
        duration: 5000,
        position: 'bottom-right'
      })
    },
    onError: (error: any) => {
      toast({
        title: 'Error Editing Internal Features',
        description: error?.message || 'An unknown error occurred',
        status: 'error',
        duration: 5000,
        position: 'bottom-right'
      })
    }
  })
  return editInternalFeatures
}

export const useUpsertExternalFeatures = () => {
  const toast = useToast()
  const { mutate: editExternalFeatures } = useMutation({
    mutationFn: async ({
      portfolioHomeId,
      data
    }: {
      portfolioHomeId: string
      data: ExternalFeatures
    }) => {
      if (!portfolioHomeId) {
        return
      }
      return axios.put(`/admin/portfolio_homes/${portfolioHomeId}/external_features`, data)
    },
    onSuccess: () => {
      toast({
        title: 'External Features Edited',
        status: 'success',
        duration: 5000,
        position: 'bottom-right'
      })
    },
    onError: (error: any) => {
      toast({
        title: 'Error Editing External Features',
        description: error?.message || 'An unknown error occurred',
        status: 'error',
        duration: 5000,
        position: 'bottom-right'
      })
    }
  })
  return editExternalFeatures
}
